import React, { Component } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "../../../../../src/main.scss";
import moment from "moment";
import _ from "lodash";
import { css } from "@emotion/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class PlanningCreche extends Component {
  calendarComponentRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      calendarWeekends: true,
      calendarEvents: [],
      nextEventAbsence: {},
      nextAbsence: {},
      initialized: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  toggleWeekends = () => {
    this.setState({
      calendarWeekends: !this.state.calendarWeekends,
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.dataPlanningCreche !== this.props.dataPlanningCreche) {
      let dataPlanningCreche = !_.isEmpty(
        this.props.dataPlanningCreche.fermetures
      )
        ? this.props.dataPlanningCreche.fermetures.map((Events) => {
            if (!_.isEmpty(Events) && !_.isEmpty(Events.dateTimeDebut)) {
              var objectEvent = { textColor: "white" };
              objectEvent.title = Events.commentaire;
              objectEvent.start = moment(Events.dateTimeDebut).format();
              objectEvent.end = moment(Events.finSeance).format();
              objectEvent.id = Events.id;
              return objectEvent;
            }
          })
        : [];
      this.setState({
        calendarEvents: dataPlanningCreche,
      });
    }
  }
  handleClick(info) {
    let obj = {
      start: info.event._instance.range.start,
      end: info.event._instance.range.end,
      id: info.event.id,
    };

    this.props.handleClickFermeture(obj);
  }

  render() {
    return (
      <FullCalendar
        displayEventTime="false"
        defaultView="dayGridMonth"
        locale="fr"
        style={"font-size: 0em;"}
        header={{
          left: "prev",
          center: "title",
          right: "next",
        }}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        ref={this.calendarComponentRef}
        events={this.state.calendarEvents}
        dateClick={this.handleDateClick}
        eventClick={this.handleClick}
      />
    );
  }
}

export default PlanningCreche;
